<template>
  <div
    class="horizontal-table-container"
    :class="{
      'horizontal-table-container--scroll': hasScroll,
      'horizontal-table-container--end': end,
    }"
  >
    <perfect-scrollbar ref="scroll" @scroll="scroll">
      <div ref="container" class="horizontal-table-container__scroll">
        <slot></slot>
        <div ref="observer" class="horizontal-table-container__observer"></div>
      </div>
    </perfect-scrollbar>
  </div>
</template>

<script>
export default {
  name: "horizontal-table",

  props: {
    fixHeader: {
      type: Boolean,
      default: false,
    },
    headerTag: {
      type: String,
      default: "tr",
    },
  },

  data() {
    return {
      hasScroll: false,
      end: false,
      topFixed: false,
      rootTop: 0,
    };
  },

  mounted() {
    this._root = document.querySelector(".layout");
    this.rootTop = this._root.getBoundingClientRect().top;

    const resizeHandler = () => {
      this.rootTop = this._root.getBoundingClientRect().top;
    };

    window.addEventListener("resize", resizeHandler);

    const handler = () => {
      this.$nextTick(() => {
        this.updateFix();
      });
    };
    window.addEventListener("resize", handler);

    const layout = document.querySelector(".layout");
    layout.addEventListener("scroll", handler);

    setTimeout(() => {
      handler();
    });

    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        this.$emit("nextPage");
      }
    });

    observer.observe(this.$refs.observer);

    const mutationObserver = new MutationObserver(() => {
      handler();
    });
    mutationObserver.observe(this.$refs.container, {
      childList: true,
      subtree: true,
    });

    this.onDispose = () => {
      window.removeEventListener("resize", handler);
      window.removeEventListener("resize", resizeHandler);
      layout.removeEventListener("scroll", handler);
      mutationObserver.disconnect();
      observer.unobserve(this.$refs.observer);
    };
  },

  beforeDestroy() {
    this.onDispose();
  },

  methods: {
    scroll() {
      this.update();
    },
    update() {
      const scroll = this.$refs.scroll.$el;

      this.hasScroll = scroll.scrollWidth > scroll.clientWidth;
      this.end = scroll.clientWidth + scroll.scrollLeft === scroll.scrollWidth;
    },
    updateFix() {
      if (!this.fixHeader) return;

      if (!this._thead) {
        this._thead = this.$el.querySelector(this.headerTag);
      }

      const thead = this._thead;
      if (!thead) return;

      const rect = this.$el.getBoundingClientRect();

      if (rect.top < this.rootTop && rect.bottom > this.rootTop) {
        this.topFixed = true;
        thead.classList.add("fixed", "fixed-shadow");
        thead.style.transform = `translateY(${this.rootTop - rect.top - 1}px)`;
        return;
      }

      this.topFixed = false;
      thead.classList.remove("fixed", "fixed-shadow");
      thead.style.transform = "translateY(0)";
    },
  },
};
</script>

<style lang="scss">
@import "~@/assets/styles/vars";
.horizontal-table-container {
  font-size: 13px;
  position: relative;

  &:before {
    content: "";
    position: absolute;
    top: 0;
    bottom: 12px;
    left: 0;
    border-right: 1px solid $color-border-light;
    z-index: 4;
  }

  &__scroll {
    position: relative;
    display: inline-block;
    margin-bottom: 12px;
  }

  // .ps {

  //   border-left: 1px solid $color-border-light;
  // }

  &__observer {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    width: 1px;
  }

  tr.fixed {
    position: relative;
    z-index: 5;
    background: white;

    box-shadow: 0 4px 10px rgba(0, 21, 80, 0.15);

    &:after {
      content: "";
      position: absolute;
      bottom: 1px;
      left: 0;
      right: 0;
      border-bottom: 1px solid #dfe4ef;
    }
  }

  &.horizontal-table-container--scroll:not(.horizontal-table-container--end) {
    &:after {
      content: "";
      position: absolute;
      right: 0;
      top: 0;
      bottom: 0;
      width: 10px;
      background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #ffffff 100%);
    }
  }

  td,
  th {
    padding: 10px;
    border: 1px solid $color-border-light;
    line-height: 1.2;
  }

  th {
    color: $color-label;
    font-size: 12px;
    font-weight: 500;

    padding-top: 5px;
    padding-bottom: 5px;

    border-bottom-width: 1px;
    border-left-width: 0;

    background: white;

    position: sticky;
    left: -1px;
    z-index: 2;

    &:after {
      content: "";
      position: absolute;
      left: 100%;
      width: 10px;
      top: 0;
      bottom: 0;
      background: linear-gradient(90deg, #001550 0%, rgba(255, 255, 255, 0) 100%);
      opacity: 0.15;
    }
  }

  .ps__rail-x {
    opacity: 1 !important;
    background: white;

    .ps__thumb-x {
      height: 4px;
      background: $color-secondary;
      bottom: 9px;
    }

    &:hover,
    &:focus,
    &.ps--clicking {
      opacity: 1;

      .ps__thumb-x {
        height: 4px !important;
        background: $color-secondary !important;
      }
    }

    @media (max-width: 992px) {
      display: none !important;
    }
  }

  .ps__rail-x {
    position: fixed;
    bottom: 0 !important;
    left: 230px !important;
    z-index: 5;

    &:before {
      content: "";
      position: absolute;
      box-shadow: 0px 0px 15px rgba(0, 21, 80, 0.3);
      left: -30px;
      width: calc(100vw - 200px);
      bottom: 0;
      height: 25px;
      background: white;
    }
  }

  .app__layout_sidebar-collapsed & {
    .ps__rail-x {
      left: 90px !important;

      &:before {
        width: calc(100vw - 60px);
      }
    }
  }
}
.fixed-shadow {
  position: relative;
  z-index: 5;
  background: white;

  box-shadow: 0 4px 10px rgba(0, 21, 80, 0.15);

  &:after {
    content: "";
    position: absolute;
    bottom: 1px;
    left: 0;
    right: 0;
    border-bottom: 1px solid #dfe4ef;
  }
}
</style>
